import type { TourDefinition } from '../training/tours';

/**
 * Тур фінансів замовлення. Ідентифікатор для реєстрації: 'finance-matter'.
 * Цілі — атрибути data-tour у features/finance/matter/* (сторінка /finance/matters/:id; вхід — посилання
 * у вкладці «Оплати» картки замовлення юридичного контуру або вибір замовлення в заголовку модуля).
 */
export const FINANCE_MATTER_TOUR_ID = 'finance-matter';

export const FINANCE_MATTER_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Фінанси замовлення',
  summary: 'План і факт ЧЗ та маржі, «правило 100 USD», оплати з відсотками за одержувачем, реєстр витрат і погодження гарантованих витрат.',
  missingHint: 'Відкрийте фінансову вкладку замовлення — підказки прив’яжуться до її розділів.',
  steps: [
    {
      id: 'planfact',
      target: 'finance-matter-planfact',
      title: 'План і факт',
      body: 'ЧЗ = оплати − собівартість (праця й витрати) − податок − маркетинг − фонд компенсацій. План рахується від суми угоди, факт — від підтверджених оплат; на ширшому екрані поруч — колонка відхилення «факт − план».',
      placement: 'bottom',
    },
    {
      id: 'rule100',
      target: 'finance-matter-rule100',
      title: '«Правило 100 USD»',
      body: 'Вартість години = оплати / години. Якщо вона нижча за поріг із параметрів фінансового директора, система запитає в юриста причину — без показу сум.',
    },
    {
      id: 'payments',
      target: 'finance-matter-payments',
      title: 'Оплати й відсотки',
      body: 'Податковий відсоток залежить від одержувача оплати. Невідомий одержувач рахується за типовим відсотком — додайте його до довідника одержувачів.',
    },
    {
      id: 'expenses',
      target: 'finance-matter-expenses',
      title: 'Реєстр витрат',
      body: 'Плановані й фактичні витрати веде фінансова роль. Гарантовані після проходження шлюзу старту змінюються лише запитом із причиною — його погоджує інша уповноважена особа.',
    },
    {
      id: 'changes',
      target: 'finance-matter-changes',
      title: 'Запити на погодження',
      body: 'Тут видно, хто і чому просить змінити гарантовані витрати, що було й що стане. Власний запит погоджує інша людина; відхилення — з поясненням.',
    },
  ],
};
